import { render } from "./PrivacyPolice.vue?vue&type=template&id=fe49d788"
import script from "./PrivacyPolice.vue?vue&type=script&lang=js"
export * from "./PrivacyPolice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__